module.exports = __webpack_public_path__ + "static/devcon5-8c7f5b0da8a0ace5f2e6762bb6499a01.png";